<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title6"> </title-bar>
    <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px">
      <!-- <img src="../../../assets/img/bonus/bonus4.png" width="100%" /> -->
    </div>
    <div class="content-a">
      <div v-if="readError" class="read-error">{{ readError }}</div>
      <div class="content-c3">
        <div class="d-flex">
          <vue-qr
            :text="inviteCode"
            :size="100"
            class="content-c3--qr"
            :margin="8"
          ></vue-qr>
          <div class="content-c3--info" style="width: 70%">
            <p class="font-color">{{ $lang.bonus_txt23 }}</p>
            <div class="content-c3--b">
              <p class="content-c3--link">{{ inviteCode }}</p>
              <img
                @click="copyText(1)"
                class="m-l-10 content-c3--copy"
                width="20px"
                src="../../../assets/img/drawer/drawer_copy.png"
              />
            </div>
            <p class="m-t-5">
              <span class="font-color">{{ $lang.bonus_txt24 }} </span>
              <span class="info-color">{{ inviteCode2 }}</span>
              <img
                @click="copyText(2)"
                class="m-l-5 content-c3--copy"
                width="11px"
                src="../../../assets/img/drawer/drawer_copy.png"
              />
            </p>
          </div>
        </div>
        <div>
          <img
            class="m-t-20"
            src="../../../assets/img/share/share_list2.png"
            style="width: 100%"
          />
        </div>
        <p class="font-color m-t-5">
          {{ $lang.bonus_txt25 }}
          <span class="info-color">{{ result || 0 }}</span>
          {{ (result || 0) === 1 ? ($lang.bonus_txt26_single || $lang.bonus_txt26) : $lang.bonus_txt26 }}
          <span class="info-color">{{ $lang.Detalhes }}</span>
        </p>
      </div>

      <div class="content-bottom">
        <div
          v-for="(item, index) in chestList"
          :key="index"
          style="width: 14%; text-align: center"
          :class="{ isR: item.isR === 'right', isL: item.isL === 'left' }"
        >
          <div v-if="item.img && item.people">
            <div v-if="item.people <= treasureLevel">
              <img class="img-content" :src="item.img_open" />
            </div>
            <div
              v-else-if="treasureWritable && result >= item.people && item.people > treasureLevel"
              @click="ReceiveTreasure"
            >
              <img class="img-content" :src="item.img_isOpen" />
            </div>
            <div v-else>
              <img class="img-content" :src="item.img" />
            </div>
            <p class="chest-amount">
              {{ $formatNumberWithCommas(item.count) }}
            </p>
            <p class="chest-people">
              {{ item.people }}
              {{ item.people === 1 ? ($lang.bonus_txt26_single || $lang.bonus_txt26) : $lang.bonus_txt26 }}
            </p>
          </div>
          <img
            v-if="item.icon"
            :src="item.icon"
            style="width: 18px; margin-left: 20px; margin-bottom: 24px"
          />
          <div v-if="item.icon2">
            <img :src="item.icon2" style="width: 18px" />
          </div>
          <img
            v-if="item.icon3"
            :src="item.icon3"
            style="width: 18px; margin-left: 20px; margin-bottom: 24px"
          />
        </div>
      </div>
      <p class="t-c f-t-15 f-w m-t-10 l-h-20">
        {{ $lang.bonus_txt27 }}<br />
        {{ $lang.bonus_txt28 }}
      </p>
      <div class="content-refer">
        <img src="../../../assets/img/refer_friend/img_wallet.png" width="60" />
        <p class="m-l-10 wihte-color" style="margin-left: 16px">
          {{ $lang.bonus_txt29 }}<br /><span class="info-color">{{
            $lang.bonus_txt30
          }}</span>
        </p>
      </div>
      <div class="content-refer2">
        <img src="../../../assets/img/refer_friend/img_cion.png" width="72" />
        <p class="m-l-10 wihte-color">
          {{ $lang.bonus_txt31 }}<br /><span class="info-color">{{
            $lang.bonus_txt32
          }}</span>
        </p>
      </div>
      <!-- <div class="content-c2">Detalhes do Evento</div> -->
      <div
        class="d-flex f-t-15 f-w m-t-10 m-b-10"
        style="justify-content: center"
      >
        <span class="share-bot-l"></span>
        <span>{{ $lang.common_txt35 }}</span>
        <span class="share-bot-r"></span>
      </div>
      <div
        v-html="$lang.bonus_txt33"
        class="l-h-20 font-color"
        style="
          margin-bottom: 10px;
          line-height: 20px;
          border-radius: 15px;
          padding: 0 10px 10px;
        "
      ></div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import { Init, TreasureReceiveInit, ReceiveTreasure } from '@/api/common'
import { failMessage as rewardFailMessage, hasRewardIssueProof, hasUnavailableMarker, isClaimSuccess as rewardClaimSuccess, isNeedLogin, isOkResponse, responseContent } from '../activity/rewardApi'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import {
  copyTextToClipboard,
  safeInviteCode,
  safeInviteUrl
} from '@/components/share/shareSafety'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function getBrowserWindow() {
  try {
    return typeof window === 'undefined' ? null : window
  } catch (e) {
    return null
  }
}

function browserLocationValue(key) {
  try {
    const browserWindow = getBrowserWindow()
    const windowLocation = browserWindow && browserWindow.location
    const value = windowLocation && windowLocation[key]
    return value ? String(value) : ''
  } catch (e) {
    return ''
  }
}

export default {
  name: 'ShareOnes',
  // eslint-disable-next-line vue/no-unused-components
  components: { VueQr },
  data() {
    return {
      inviteCode: '',
      inviteCode2: '',
      chestList: [
        {
          people: 1,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 2,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 3,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 4,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 8,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 7,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 6,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 5,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 9,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 10,
          count: 2000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 15,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 20,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 40,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 35,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 30,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 25,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 45,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 50,
          count: 10000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 60,
          count: 20000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 70,
          count: 20000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 150,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 100,
          count: 20000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 90,
          count: 20000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 80,
          count: 20000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 200,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 250,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 300,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 350,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 600,
          count: 200000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 500,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 450,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 400,
          count: 100000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 700,
          count: 200000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 800,
          count: 200000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 900,
          count: 200000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 1000,
          count: 200000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 3000,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 2500,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 2000,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 1500,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 3500,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 4000,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 4500,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 5000,
          count: 1000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 9000,
          count: 2000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 8000,
          count: 2000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 7000,
          count: 2000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 6000,
          count: 2000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 10000,
          count: 2000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          count: 10000000,
          people: 15000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 20000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 25000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {
          people: 45000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 40000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 35000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 30000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isL: 'left'
        },
        {
          people: 50000,
          count: 10000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 60000,
          count: 20000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 70000,
          count: 20000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon: require('@/assets/img/refer_friend/img_right.png')
        },
        {
          people: 80000,
          count: 20000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon2: require('@/assets/img/refer_friend/img_down.png'),
          isR: 'right'
        },
        {},
        {},
        {},
        {},
        {
          people: 100000,
          count: 20000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        },
        {
          icon3: require('@/assets/img/refer_friend/img_left.png')
        },
        {
          people: 90000,
          count: 20000000,
          img: require('@/assets/img/refer_friend/img_box_unopened.png'),
          img_open: require('@/assets/img/refer_friend/img_open_box.png'),
          img_isOpen: require('@/assets/img/refer_friend/img_isOpen_box.png')
        }
      ],
      currentCount: 0,
      treasureLevel: 0,
      treasureWritable: true,
      readError: ''
    }
  },
  mounted() {
    if (this.token) {
      this.Init()
      this.TreasureReceiveInit()
    }
  },
  computed: {
    result() {
      // 接口 currentCount 表示“拥有到第几等级宝箱的人数”（待开 + 已开）
      // 因此展示与可开判断直接使用 currentCount 对比 item.people 即可。
      return this.currentCount || 0
    }
  },
  methods: {
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isRewardNeedLogin(res) {
      if (isNeedLogin(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (body.need_login === true || body.needLogin === true || [body.status, body.state, body.code, body.errorCode, body.need_login, body.needLogin].some(value => String(value || '').trim().toLowerCase() === 'need_login')) return true
        ;['content', 'data', 'page', 'extra'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasRewardUnavailableMarker(res) {
      if (hasUnavailableMarker(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.readOnly,
          body.readOnlyMode,
          body.read_only_mode,
          body.readOnlyReward,
          body.read_only_reward,
          body.readOnlyAction,
          body.read_only_action,
          body.read_only,
          body.mock_fallback,
          body.not_implemented,
          body.not_supported,
          body.need_login,
          body.needLogin,
          body.notSupported,
          body.unsupported,
          body.technicalMarker,
          body.technical_marker,
          body.backendFailure,
          body.backend_failure,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.fallback,
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.writeBlocked,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.falseProof,
          body.false_proof,
          body.failClosed,
          body.fail_closed,
          body.unimplemented,
          body.failed,
          body.readonly,
          body.notImplemented,
          body.mock,
          body.mockMode,
          body.mock_mode,
          body.mockFallback,
          body.write_blocked,
          body.stub,
          body.msg,
          body.message,
          body.reason,
          body.status,
          body.state,
          body.result,
          body.code,
          body.errorCode,
          body.paymentStatusUnconfirmed,
          body.payment_status_unconfirmed,
          body.paymentStatus,
          body.payment_status,
          body.rewardStatus,
          body.reward_status
        ]
        const proofValues = [
          body.writeProof,
          body.write_proof,
          body.rewardProof,
          body.reward_proof,
          body.orderProof,
          body.order_proof,
          body.affectedProof,
          body.affected_proof,
          body.serverProof,
          body.server_proof
        ]
        if (proofValues.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return true
        const markers = ['未接入', 'mock', 'mockMode', 'mock_mode', 'fallback', 'dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'stub', '只读', 'readOnlyMode', 'read_only_mode', 'readOnlyReward', 'read_only_reward', 'readOnlyAction', 'read_only_action', '阻止假成功', 'writeBlocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'writeProof', 'write_proof', 'falseProof', 'false_proof', 'false proof', 'failClosed', 'fail_closed', 'fail closed', 'backendBlocked', 'rewardBackendBlocked', 'backend_blocked', 'reward_backend_blocked', 'technicalMarker', 'technical_marker', 'technical marker', 'backendFailure', 'backend_failure', 'backend failure', 'technicalException', 'technical_exception', 'technical exception', 'technicalError', 'technical_error', 'technical error', 'not_implemented', 'not_supported', 'not supported', 'need_login', 'need login', 'need-login', 'unsupported', 'unimplemented', 'failed']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
    },
    showFailToast(res, fallback) {
      this.$toast({
        message: this.failMessage(res, fallback),
        icon: 'cross'
      })
    },
    showReadFailToast(res, fallback) {
      this.readError = this.failMessage(res, fallback || this.$lang.network_error || '活动请求失败，请稍后重试。')
      this.$toast({
        message: this.readError,
        icon: 'cross'
      })
    },
    safeRuleList(value) {
      if (Array.isArray(value)) return value
      if (!value) return []
      if (typeof value === 'string') {
        try {
          return this.safeRuleList(JSON.parse(value))
        } catch (e) {
          return []
        }
      }
      if (typeof value !== 'object') return []
      return this.firstRuleList(value)
    },
    safeNumber(value, fallback = 0) {
      const n = Number(typeof value === 'string' ? value.replace(/,/g, '') : value)
      return Number.isFinite(n) ? n : fallback
    },
    firstValue(source, keys, fallback = '') {
      if (!source) return fallback
      for (const key of keys) {
        if (source[key] !== undefined && source[key] !== null && source[key] !== '') return source[key]
      }
      return fallback
    },
    firstRuleList(source, depth = 0) {
      if (!source || typeof source !== 'object' || depth > 5) return []
      const listKeys = ['ruleList', 'rules', 'list', 'records', 'dataList', 'items', 'rows']
      for (const key of listKeys) {
        const value = source[key]
        if (Array.isArray(value)) return value
        if (typeof value === 'string') {
          const list = this.safeRuleList(value)
          if (list.length) return list
        }
        if (value && typeof value === 'object') {
          const list = this.firstRuleList(value, depth + 1)
          if (list.length) return list
        }
      }
      for (const key of ['content', 'payload', 'extra', 'page', 'data', 'body', 'detail', 'info']) {
        const value = source[key]
        if (!value || (typeof value !== 'object' && typeof value !== 'string')) continue
        const list = typeof value === 'string' ? this.safeRuleList(value) : this.firstRuleList(value, depth + 1)
        if (list.length) return list
      }
      return []
    },
    hasRewardWriteProof(res) {
      if (this.hasRewardUnavailableMarker(res)) return false
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const proofs = [
          body.writeProof,
          body.write_proof,
          body.affectedProof,
          body.affected_proof,
          body.affectedRowsProof,
          body.affected_rows_proof,
          body.count,
          body.serverProof,
          body.server_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (proofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return false
        const positiveProofs = [
          body.rewardProof,
          body.reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (positiveProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const recordProofs = [
          body.recordNo,
          body.record_no,
          body.recordId,
          body.record_id,
          body.rewardRecordNo,
          body.reward_record_no,
          body.rewardRecordId,
          body.reward_record_id,
          body.receiveRecordNo,
          body.receive_record_no,
          body.receiveRecordId,
          body.receive_record_id,
          body.claimRecordNo,
          body.claim_record_no,
          body.claimRecordId,
          body.claim_record_id
        ]
        const hasRecordProof = recordProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })
        const aliasProofs = [
          body.serverRewardProof,
          body.server_reward_proof
        ]
        if (hasRecordProof && aliasProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const concreteProofs = [
          body.rewardProof,
          body.reward_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (concreteProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasExplicitRewardSuccess(res) {
      const c = responseContent(res)
      return [
        c.receiveSuccess,
        c.claimSuccess,
        c.signSuccess,
        c.paySuccess,
        c.success,
        c.received,
        c.claimed,
        c.signed
      ].some(value => value === true || value === 1 || ['1', 'true', 'success', 'ok'].includes(String(value == null ? '' : value).trim().toLowerCase()))
    },
    isReceiveSuccess(res) {
      return !this.hasRewardUnavailableMarker(res) && rewardClaimSuccess(res) && this.hasExplicitRewardSuccess(res) && (hasRewardIssueProof(res) || this.hasRewardWriteProof(res)) && this.hasRewardWriteProof(res)
    },
    isRewardWriteDisabled(content, source) {
      const c = content || {}
      return this.hasRewardUnavailableMarker(source || c) ||
        this.hasRewardUnavailableMarker(c) ||
        c.rewardWritable === false ||
        String(c.rewardWritable).trim().toLowerCase() === 'false' ||
        c.writeEnabled === false ||
        String(c.writeEnabled).trim().toLowerCase() === 'false'
    },
    hasTreasureReadData(content) {
      const c = content || {}
      const detail = c.detail || c.info || {}
      const normalized = {
        ...c,
        ...detail
      }
      return this.firstValue(normalized, ['treasureLevel', 'treasure_level', 'level', 'claimedLevel', 'claimed_level', 'currentCount', 'current_count', 'inviteCount', 'invite_count', 'peopleCount', 'people_count'], '') !== '' ||
        this.safeRuleList(normalized).length > 0
    },
    hasInviteReadData(content) {
      return this.firstValue(content || {}, ['inviteCode', 'invite_code', 'invitationCode', 'invitation_code', 'referralCode', 'referral_code', 'code'], '') !== ''
    },
    safeBrowserOrigin() {
      return browserLocationValue('origin')
    },
    safeCountry() {
      const storage = getLocalStorage()
      return storage ? safeGetStorageItem(storage, 'country') : ''
    },
    applyRuleList(ruleList) {
      const rules = this.safeRuleList(ruleList)
        .map((rule) => ({
          levelMin: this.safeNumber(this.firstValue(rule, ['levelMin', 'level_min', 'minLevel', 'min_level', 'peopleMin', 'people_min', 'minPeople', 'min_people'], 0)),
          levelMax: this.safeNumber(this.firstValue(rule, ['levelMax', 'level_max', 'maxLevel', 'max_level', 'peopleMax', 'people_max', 'maxPeople', 'max_people'], 0)),
          reward: this.safeNumber(this.firstValue(rule, ['reward', 'rewardAmount', 'reward_amount', 'amount', 'bonus', 'count'], 0))
        }))
        .filter((rule) => rule.levelMax > 0)
      if (!rules.length) return
      this.chestList.forEach((item) => {
        const people = Number(item && item.people) || 0
        if (!people) return
        const rule = rules.find(
          (r) => people >= r.levelMin + 1 && people <= r.levelMax
        )
        if (rule) {
          item.count = rule.reward
        }
      })
    },
    async ReceiveTreasure() {
      if (!this.token) {
        this.requireLogin()
        return
      }
      try {
        const data = await ReceiveTreasure()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isReceiveSuccess(data)) {
          await this.TreasureReceiveInit()
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
        } else {
          this.showFailToast(data)
        }
      } catch (e) {
        this.showFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      }
    },
    async TreasureReceiveInit() {
      try {
        const data = await TreasureReceiveInit()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
          this.treasureWritable = false
        } else if (isOkResponse(data) && this.hasTreasureReadData(responseContent(data))) {
          const content = responseContent(data)
          const detail = content.detail || content.info || {}
          const normalized = {
            ...content,
            ...detail
          }
          this.treasureWritable = !this.isRewardWriteDisabled(normalized, data)
          this.treasureLevel = this.safeNumber(this.firstValue(normalized, ['treasureLevel', 'treasure_level', 'level', 'claimedLevel', 'claimed_level'], 0))
          const currentCount = this.safeNumber(this.firstValue(normalized, ['currentCount', 'current_count', 'inviteCount', 'invite_count', 'peopleCount', 'people_count'], 0))
          this.currentCount = this.treasureWritable ? currentCount : this.treasureLevel
          if (this.treasureWritable) {
            this.applyRuleList(normalized)
          }
          this.readError = ''
        } else {
          this.showReadFailToast(data)
        }
      } catch (e) {
        this.showReadFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      }
    },
    async Init() {
      const inviteOrigin = this.safeBrowserOrigin()
      const inviteCountry = this.safeCountry()
      try {
        const data = await Init()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.hasRewardUnavailableMarker(data)) {
          this.showReadFailToast(data, this.$lang.common_txt114 || 'Invite code is unavailable')
        } else if (isOkResponse(data) && this.hasInviteReadData(responseContent(data))) {
          const content = responseContent(data)
          const inviteCode = safeInviteCode(this.firstValue(content, ['inviteCode', 'invite_code', 'invitationCode', 'invitation_code', 'referralCode', 'referral_code', 'code'], ''))
          this.inviteCode = safeInviteUrl(
            inviteOrigin,
            inviteCountry,
            inviteCode
          )
          this.inviteCode2 = inviteCode
          if (!inviteCode) {
            this.showFailToast(data, this.$lang.common_txt114 || 'Invite code is unavailable')
          }
          this.readError = ''
        } else {
          this.showReadFailToast(data)
        }
      } catch (e) {
        this.showReadFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      }
    },
    copyText(i) {
      const copyValue = String((i === 1 ? this.inviteCode : this.inviteCode2) || '').trim()
      if (!copyValue) {
        this.$toast({
          message: this.$lang.noempt || this.$lang.common_txt114 || 'No data available',
          icon: 'cross'
        })
        return
      }
      try {
        const copied = copyTextToClipboard(copyValue)
        this.$toast({
          message: copied === true ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
          icon: copied === true ? 'success' : 'cross'
        })
      } catch (e) {
        this.$toast({
          message: (e && (e.msg || e.message)) || this.$lang.copy_failed || 'Copy failed',
          icon: 'cross'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c3 {
  display: flex;
  background: @cont-bg;
  padding: 18px 12px;
  font-weight: bold;
  border-radius: 13px;
  flex-flow: row wrap;
  border: 1px solid @info2-color;
}
.read-error {
  margin-bottom: 8px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
  text-align: center;
}
.content-c3--info {
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.content-c3--b {
  margin-top: 5px;
  display: flex;
  background: @cont-bg;
  border: 1px solid #89898b;
  border-radius: 10px;
  padding: 4px 10px;
  line-height: 18px;
  align-items: center;
  letter-spacing: 0;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}
.content-c3--link {
  flex: 1 1 0;
  min-width: 0;
  margin: 0;
  font-size: var(--vk-fs-xs);
  word-break: break-all;
  overflow-wrap: anywhere;
  white-space: normal;
}
.content-c3--copy {
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}
.content-c3--qr {
  margin-right: 10px;
  border-radius: 8px;
  width: 90px;
  height: 90px;
}
.content-refer {
  // background: linear-gradient(to right, #1f3fa2, #1e336f, #292a2a);
  background: linear-gradient(to right, #3470d2, #2f6cd0);
  display: flex;
  border-radius: 13px;
  padding: 15px 10px;
  align-items: center;
  font-size: var(--vk-fs-base);
  margin-top: 15px;
}
.content-refer2 {
  // background: linear-gradient(to right, #686627, #424229, #292a2a);
  background: linear-gradient(to right, #17a99f, #11a49c);
  display: flex;
  border-radius: 13px;
  padding: 10px;
  align-items: center;
  font-size: var(--vk-fs-base);
  margin-top: 18px;
}
.content-bottom {
  display: flex;
  flex-flow: wrap row;
  border-radius: 13px;
  padding: 10px 15px 25px 5px;
  // background: @cont-bg;
  align-items: center;
  margin-top: 15px;
}
.isR {
  text-align: right !important;
  width: 100% !important;
  padding-right: 5%;
  margin: 15px 0 8px;
}
.isL {
  text-align: left !important;
  width: 100% !important;
  padding-left: 5%;
  margin: 15px 0 8px;
}
.content-c2 {
  font-size: var(--vk-fs-md);
  margin-top: 18px;
  background-image: url('../../../assets/img/bonus/cashback_rate_vip.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 2px 10px;
  font-weight: bold;
}
.content-a {
  padding: 10px;
  // width: 94%;
  // margin: 12px auto;
  // z-index: 9 !important;
  // position: absolute;
  // right: 0;
  // left: 0;
}
.img-content {
  width: 72px;
  max-width: 100%;
  display: block;
  margin: 0 auto;
  position: relative;
}
.chest-amount {
  font-size: var(--vk-fs-xs);
  font-weight: bold;
  color: #ffd700;
  text-align: center;
  margin: 2px 0 0;
  line-height: 1.2;
  white-space: nowrap;
}
.chest-people {
  font-size: var(--vk-fs-2xs);
  color: #95a1c1;
  text-align: center;
  margin: 0;
  line-height: 1.3;
  white-space: nowrap;
}
@media (min-width: 769px) {
  .content-a {
    width: var(--vk-pc-col) !important;
    overflow-y: auto;
    height: 100vh;
    /* 隐藏滚动条样式 */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
